import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  input,
  inject,
} from '@angular/core';
import { WINDOW } from '@seven1/angular/ssr';

@Directive({
  selector: '[lazyBgDirective]',
  standalone: true,
})
export class lazyBgDirective implements OnInit {
  lazyBgDirective = input<string>('');
  elementRef = inject(ElementRef);
  renderer = inject(Renderer2);
  private _window = inject(WINDOW);

  ngOnInit() {
    if (this._window && 'IntersectionObserver' in this._window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadBackground();
            observer.unobserve(this.elementRef.nativeElement);
          }
        });
      });
      observer.observe(this.elementRef.nativeElement);
    } else {
      // Fallback for browsers without IntersectionObserver support
      this.loadBackground();
    }
  }

  private loadBackground() {
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      'backgroundImage',
      `url(${this.lazyBgDirective()})`,
    );
  }
}
